export var ColorSemanticHex;
(function (ColorSemanticHex) {
    ColorSemanticHex["primary30"] = "#3333A5";
    ColorSemanticHex["primary40"] = "#00008F";
    ColorSemanticHex["primary50"] = "#000072";
    ColorSemanticHex["principalActive"] = "#3333A5";
    ColorSemanticHex["principalDefault"] = "#00008F";
    ColorSemanticHex["principalHover"] = "#000072";
    ColorSemanticHex["secondaryActive"] = "#3333A5";
    ColorSemanticHex["secondaryHover"] = "#00008F";
    ColorSemanticHex["business30"] = "#DF7E65";
    ColorSemanticHex["business40"] = "#D24723";
    ColorSemanticHex["business50"] = "#A8391C";
    ColorSemanticHex["businessActive"] = "#DF7E65";
    ColorSemanticHex["businessDefault"] = "#D24723";
    ColorSemanticHex["businessHover"] = "#A8391C";
    ColorSemanticHex["tertiaryNone"] = "transparent";
    ColorSemanticHex["tertiaryBlueFont"] = "#00008F";
    ColorSemanticHex["tertiaryBlueDefault"] = "transparent";
    ColorSemanticHex["tertiaryBlueHover"] = "#E5E5F4";
    ColorSemanticHex["tertiaryBlueActive"] = "#ADADDB";
    ColorSemanticHex["error30"] = "#D4435B";
    ColorSemanticHex["error40"] = "#C91432";
    ColorSemanticHex["error50"] = "#A11028";
    ColorSemanticHex["errorActive"] = "#D4435B";
    ColorSemanticHex["errorDefault"] = "#C91432";
    ColorSemanticHex["errorHover"] = "#A11028";
    ColorSemanticHex["warning30"] = "#DD8D69";
    ColorSemanticHex["warning40"] = "#C94E14";
    ColorSemanticHex["warning50"] = "#A13E10";
    ColorSemanticHex["success30"] = "#4DA467";
    ColorSemanticHex["success40"] = "#118635";
    ColorSemanticHex["success50"] = "#0E6B2A";
    ColorSemanticHex["validationActive"] = "#4DA467";
    ColorSemanticHex["validationDefault"] = "#118635";
    ColorSemanticHex["validationHover"] = "#0E6B2A";
    ColorSemanticHex["neutral10"] = "#FFFFFF";
    ColorSemanticHex["neutral20"] = "#FAFAFA";
    ColorSemanticHex["neutral30"] = "#F5F5F5";
    ColorSemanticHex["neutral40"] = "#E5E5E5";
    ColorSemanticHex["neutral50"] = "#CCCCCC";
    ColorSemanticHex["neutral60"] = "#999999";
    ColorSemanticHex["neutral70"] = "#5F5F5F";
    ColorSemanticHex["neutral80"] = "#333333";
    ColorSemanticHex["containerLight"] = "#FFFFFF";
    ColorSemanticHex["containerMiddle"] = "#FAFAFA";
    ColorSemanticHex["containerHard"] = "#F5F5F5";
    ColorSemanticHex["containerInfo"] = "#E5E5E5";
    ColorSemanticHex["disabled"] = "#5F5F5F";
    ColorSemanticHex["inverseHover"] = "#FFFFFF";
    ColorSemanticHex["textTitle"] = "#00008F";
    ColorSemanticHex["textBody"] = "#333333";
    ColorSemanticHex["textBodyContrasted"] = "#FFFFFF";
    ColorSemanticHex["textLight"] = "#5F5F5F";
    ColorSemanticHex["textLighter"] = "#999999";
    ColorSemanticHex["textLink"] = "#00008F";
    ColorSemanticHex["textSuccess"] = "#118635";
    ColorSemanticHex["textError"] = "#C91432";
})(ColorSemanticHex || (ColorSemanticHex = {}));
